import styled, { css } from 'styled-components';
import { ifProp, palette } from 'styled-tools';

import { Button, FontSizes, FontWeights, minWidth, Text, units } from '@calm-web/design-system';

export const Container = styled.div`
	text-align: center;
	margin-bottom: ${units(3)};

	${minWidth('desktop')} {
		text-align: left;
	}
`;

export const Header = styled(Text).attrs({
	noMargin: true,
	el: 'h1',
	color: 'blackAlpha80',
	weight: FontWeights.Medium,
	size: FontSizes['2xl'],
})`
	margin-bottom: 12px;

	${minWidth('desktop')} {
		margin-bottom: 10px;
	}
`;

export const InnerContainer = styled.div`
	color: ${palette('blackAlpha80')};

	& > p {
		margin: 0 !important;
		margin-bottom: ${units(3)} !important;

		${minWidth('desktop')} {
			margin-bottom: ${units(4)} !important;
		}
	}
`;

export const CtaButton = styled(Button)<{ isAdditionalPaddingAboveCtaButton?: boolean }>`
	${ifProp(
		'isAdditionalPaddingAboveCtaButton',
		css`
			margin-top: ${units(3)};
		`,
	)}
`;

export const StoreButtonContainer = styled.div`
	margin-bottom: ${units(3)};
	height: 40px;

	${minWidth('desktop')} {
		margin-bottom: ${units(6)};
	}
`;
